import React from 'react'
import { Avatar, Popover } from 'antd'
import { TableEventListeners } from 'antd/lib/table'

import UserAvatar from 'src/components/UserAvatar'
import { List, ListItem, ListItemMeta } from 'src/components/Ant'
import { ColumnProps } from 'src/components/Ant/Table'
import {
  Id,
  RequestAgencyStatus,
  RequestApprovalStatus,
  RequestClosingStatus,
  RequestConferenceStatus,
  RequestUserDataStatus,
  Gender
} from 'src/types'

import { WrapTable } from './styles'
import UnifiedTag from '../unified-tag'

interface User {
  gender: Gender
  name: string
  status:
    | RequestAgencyStatus
    | RequestUserDataStatus
    | RequestApprovalStatus
    | RequestConferenceStatus
    | RequestClosingStatus
  user_id: Id
}

export interface DataSource {
  organization: string
  id: Id
  request_id: Id
  organization_id: Id
  // request_number: Id
  // number: Id
  // title: string
  startDate: string
  status:
    | RequestAgencyStatus
    | RequestUserDataStatus
    | RequestApprovalStatus
    | RequestConferenceStatus
    | RequestClosingStatus
  users: User[]
  // extra?: any
}

interface Props {
  currentPage: number
  dataSource: DataSource[]
  loading: boolean
  onChange(page: number): void
  onRow?: (record: DataSource, index: number) => TableEventListeners
  totalPages: number
}

const columns: ColumnProps<unknown>[] = [
  {
    title: 'web.table.head.id',
    dataIndex: 'number',
    key: 'number'
  },
  {
    title: 'web.table.head.request',
    dataIndex: 'request_number',
    key: 'request_number'
  },
  {
    title: 'web.table.head.organization',
    dataIndex: 'organization',
    key: 'organization'
  },
  {
    title: 'web.table.head.title',
    dataIndex: 'title',
    key: 'title'
  },
  {
    title: 'web.table.head.users',
    dataIndex: 'users',
    key: 'users',
    render: (users: User[]) => (
      <Popover
        content={
          <div style={{ maxHeight: 300, overflow: 'auto' }}>
            <List
              bordered={false}
              dataSource={users}
              itemLayout="horizontal"
              renderItem={(item: User) => (
                <ListItem>
                  <ListItemMeta
                    avatar={
                      <UserAvatar
                        gender={item.gender}
                        name={item.name}
                        size="large"
                      />
                    }
                    description={<UnifiedTag status={item.status} />}
                    title={item.name}
                  />
                </ListItem>
              )}
            />
          </div>
        }
        placement="bottomLeft"
      >
        <div>
          {users.map((user, index) =>
            index > 1 ? null : (
              <UserAvatar
                className="mr-8"
                gender={user.gender}
                key={user.user_id}
                name={user.name}
              />
            )
          )}
          {users.length - 2 > 0 && <Avatar>+{users.length - 2}</Avatar>}
        </div>
      </Popover>
    )
  },
  {
    title: 'web.table.head.start-date',
    dataIndex: 'startDate',
    key: 'startDate'
  },
  // {
  //   align: 'right',
  //   title: 'web.table.head.cost',
  //   dataIndex: 'cost',
  //   key: 'cost'
  // },
  {
    title: 'web.table.head.status',
    dataIndex: 'status',
    key: 'status',
    render: (status: RequestUserDataStatus) => <UnifiedTag status={status} />
  }
]

function Table({
  currentPage,
  dataSource,
  loading,
  onChange,
  onRow,
  totalPages
}: Props) {
  return (
    <WrapTable
      className="table-striped"
      columns={columns}
      dataSource={dataSource}
      loading={loading}
      onChange={({ current }) => onChange(current)}
      // @ts-ignore
      onRow={onRow}
      pagination={{
        current: currentPage,
        pageSize: 10,
        total: totalPages
      }}
    />
  )
}

export default Table
